import React from "react";
import { Link } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ProductCard = React.memo(({ product, colClass = "", loading }) => {
  if (loading) {
    return (
      <div className={`product-card-col ${colClass} p-sm-2 p-1`}>
        <div className="product-card shadow-sm rounded-3 p-3 h-100 d-flex flex-column">
          {/* Skeleton Badge */}
          <div className="discount-badge" style={{ background: "transparent", boxShadow: "none", padding: 0 }}>
            <Skeleton width={50} height={20} borderRadius={4} />
          </div>

          <div className="product-card-img-container mb-3 text-center">
            <Skeleton height={180} className="img-fluid rounded-3" />
          </div>

          <div className="product-card-body flex-grow-1 d-flex flex-column">
            <div>
              <small className="product-card-category text-muted text-uppercase fw-medium d-block">
                <Skeleton width={80} />
              </small>
              <h6 className="product-card-title mb-2 text-muted text-capitalize">
                <Skeleton count={2} width={150} />
              </h6>
            </div>

            <div className="mt-auto product-card-pricing">
              <p className="discountedPrice mb-0 fw-bold">
                <Skeleton width={100} height={24} />
              </p>
              <div className="d-flex align-items-center gap-2 mt-1">
                <small className="text-muted">
                  <Skeleton width={60} />
                </small>
                <small className="text-success fw-medium">
                  <Skeleton width={80} />
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const { id, pname, category, price, discountedPrice, image = [] } = product;

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(price);
  };

  const discountPercentage = discountedPrice
    ? Math.round(((price - discountedPrice) / price) * 100)
    : 0;

  return (
    <div className={`product-card-col ${colClass} p-sm-2 p-1`} key={id}>
      <div className="product-card shadow-sm rounded-3 p-3 h-100 d-flex flex-column">
        {/* Discount Badge */}
        {discountPercentage > 0 && (
          <div className="discount-badge">
            {discountPercentage}% OFF
          </div>
        )}

        <div className="product-card-img-container mb-3 text-center">
          <Link to={`/product-details/${id}`} className="d-block">
            {image.length > 0 && (
              <img
                src={image[0]}
                alt={pname}
                className="img-fluid product-card-image"
                loading="lazy"
                decoding="async"
              />
            )}
          </Link>
        </div>

        <div className="product-card-body flex-grow-1 d-flex flex-column">
          <Link
            to={`/product-details/${id}`}
            className="text-decoration-none text-dark"
          >
            <small className="product-card-category text-muted text-uppercase fw-medium">
              {category}
            </small>
            <h6 className="product-card-title mb-2 text-dark text-capitalize">
              <span className="product-title-line-clamp">{pname}</span>
            </h6>
          </Link>

          <div className="mt-auto product-card-pricing">
            <p className="discountedPrice mb-0 fw-bold">
              {formatPrice(discountedPrice || price)}
            </p>
            {discountedPrice && price > discountedPrice && (
              <div className="d-flex align-items-center gap-2 mt-1">
                <small className="text-muted">
                  <del className="productprice">{formatPrice(price)}</del>
                </small>
                <small className="text-success fw-medium">
                  Save {formatPrice(price - discountedPrice)}
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProductCard;

